const VISIBLE_PET_ATTRIBUTES = [
  'DPID', 'PetName', 'PetSpecies', 'PetBreed',
  'PetChip', 'PetTattooNumber', 'PetAdditionalDetails',
];

export default VISIBLE_PET_ATTRIBUTES;
